module.exports = __webpack_public_path__ + "img/23_101.d48cb27d.png";